/**
 * format city name replacing ' -' for ','
 *
 * @param cityWithState
 * @returns {string}
 */
export const formatCity = (city: string): string =>
  city.replace(/\s-(?=[^-]*$)/, ',');
